// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { BlogProvider } from './context/BlogContext';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';
import Archive from './pages/Archive';
import About from './pages/about';
import Auth from './pages/Auth';
import './App.css';

const App = () => {
  const [loggedInUser, setLoggedInUser] = useState(null);

  const handleLogin = (user) => {
    setLoggedInUser(user);
  };

  const handleLogout = () => {
    setLoggedInUser(null);
  };

  // Protected Route 组件
  const ProtectedRoute = ({ children }) => {
    if (!loggedInUser) {
      return <Navigate to="/auth" replace />;
    }
    return children;
  };

  return (
    <BlogProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* 首页 */}
            <Route 
              path="/" 
              element={<Home loggedInUser={loggedInUser} onLogout={handleLogout} />} 
            />
            
            {/* 文章详情页 */}
            <Route 
              path="/post/:id" 
              element={<PostDetail loggedInUser={loggedInUser} onLogout={handleLogout} />} 
            />
            
            {/* 撰写文章页 (需要登录) */}
            <Route 
              path="/write" 
              element={
                <ProtectedRoute>
                  <WritePost loggedInUser={loggedInUser} onLogout={handleLogout} />
                </ProtectedRoute>
              } 
            />
            
            {/* 编辑文章页 */}
            <Route 
              path="/edit/:id" 
              element={
                <ProtectedRoute>
                  <WritePost loggedInUser={loggedInUser} onLogout={handleLogout} />
                </ProtectedRoute>
              } 
            />
            
            {/* 归档页 */}
            <Route 
              path="/archives" 
              element={<Archive loggedInUser={loggedInUser} onLogout={handleLogout} />} 
            />
            
            {/* 关于页 */}
            <Route 
              path="/about" 
              element={<About loggedInUser={loggedInUser} onLogout={handleLogout} />} 
            />
            
            {/* 认证页 (登录/注册) */}
            <Route 
              path="/auth" 
              element={<Auth loggedInUser={loggedInUser} onLogin={handleLogin} onLogout={handleLogout} />} 
            />
            
            {/* 重定向未知路由到首页 */}
            <Route 
              path="*" 
              element={<Navigate to="/" replace />} 
            />
          </Routes>
        </div>
      </Router>
    </BlogProvider>
  );
};

export default App;